import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { track, TrackMethod } from '../../../Utility/Tracking/Track';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import { LevelStatus } from '../../Level/ILevelState';
import { isEndGame } from '../../Level/LevelStateHelper';
import { spendCoins } from '../../Player/PlayerInventoryHelper';

export default class BaseBoosterBehavior {
    public play(state: IGameState): IGameState {
        return state;
    }

    public isPlayable(state: IGameState): boolean {
        // prettier-ignore
        return (
            state.levelState.status === LevelStatus.ACTIVE &&
            (this.getInventoryItem(state) > 0 || state.playerState.coins >= this.getPrice(state)) &&
            this.hasEnoughTargetCards(state)
        );
    }

    public getTargetCards(state: IGameState): string[] {
        return [];
    }

    public hasEnoughTargetCards(state: IGameState): boolean {
        return true;
    }

    protected getPrice(state: IGameState): number {
        return 0;
    }

    protected getInventoryItem(state: IGameState): number {
        return 0;
    }

    protected spendInventoryItem(state: IGameState): IGameState {
        return state;
    }

    protected spendCoins(state: IGameState): IGameState {
        const price = this.getPrice(state);

        track('mCoinsSpent', price, TrackMethod.ADD);
        if (isEndGame(state)) {
            track('mLossAversionCoinsSpent', price, TrackMethod.ADD);
        }

        trackTransaction(
            state,
            TransactionType.COIN_PURCHASE,
            TActionType.BOOSTER_USE
        );

        return {
            ...state,
            playerState: spendCoins(state.playerState, price),
        };
    }

    protected consumeItemOrCoins(state: IGameState): IGameState {
        if (this.getInventoryItem(state) > 0) {
            return this.spendInventoryItem(state);
        } else {
            return this.spendCoins(state);
        }
    }
}
